import { Box, Button, Grid2 } from "@mui/material";
import { StateEnum, StepsEnum } from "./HorizontalLinearStepper";
import RedButton from "../../Common/UI/components/RedButton";
import SNEvent from "./interfaces/SNEvent";
import useFetchMsal from "../../Common/UI/hooks/useFetchMsal";
import useURLBuilder from "../../Common/UI/hooks/useURLBuilder";
import { useState } from "react";
import { config } from "../../authConfig";
import EditedInvoice from "./interfaces/EditedInvoice";
import { LoadingIndicator } from "../../Common/UI/components/Loading";
import useIsAdminAndViewOnly from "../../Common/UI/hooks/useIsAdminAndViewOnly";
import { CommentDialog } from "./components/CommentDialog";

export default function InvoicedStep({
  handleStep,
  event,
  setEvent,
  setEditedInvoice,
}: {
  event: SNEvent;
  handleStep: (stepNum: number) => void;
  setEvent: React.Dispatch<React.SetStateAction<SNEvent>>;
  setEditedInvoice: React.Dispatch<React.SetStateAction<EditedInvoice | null>>;
}) {
  const { isViewOnly, isAdmin } = useIsAdminAndViewOnly();
  const execute = useFetchMsal();
  const urlBuilder = useURLBuilder();
  const [isSending, setSending] = useState<boolean>(false);
  const [showCommentPopup, setShowCommentPopup] = useState(false);

  const handleCloseComments = () => setShowCommentPopup(false);
  const handleArchive = async function (comment: string) {
    try {
      setSending(true);
      setEvent((prevEvent) => {
        prevEvent.comment = comment;
        return prevEvent;
      });
      const url = `${config.rootAPIUrl}${config.rootAPIList?.archive}`;
      const response = await execute("POST", url, event);
      setEvent(response);
      setSending(false);
      handleStep(StepsEnum.New);
    } catch (error) {
      console.error(error);
      throw new Error("Event archival failed!");
    }
  };

  const getInvoiceStatus = async function () {
    try {
      debugger;
      setSending(true);
      const url = urlBuilder(`${config.rootAPIUrl}${config.rootAPIList?.invoiceStatus}`, {
        id: event.id!,
      });

      const response = await execute("GET", url);
      setEvent(response.snEvent);
      setSending(false);
      if (response.snEvent.stateId === StateEnum.Paid) {
        handleStep(StepsEnum.Paid);
      }

      setEditedInvoice(response.invoice);
    } catch (error) {
      console.error(error);
      throw new Error("Pull of invoice has failed!");
    }
  };

  return (
    <LoadingIndicator show={isSending}>
      {!isViewOnly ? (
        <Grid2 container rowSpacing={2} justifyContent={"space-between"} alignItems={"center"} sx={{ paddingBottom: "20px" }}>
          <Grid2 size={4}>
            <Box>
              <RedButton
                text="REFRESH"
                disabled={false}
                onClick={async () => {
                  await getInvoiceStatus();
                }}
                style={{ margin: "10px" }}
              ></RedButton>

              {isAdmin && (
                <Button variant="outlined" onClick={() => setShowCommentPopup(true)} sx={{ marginLeft: 2 }}>
                  Archive
                </Button>
              )}
            </Box>
          </Grid2>
          <Grid2 size={8}></Grid2>
          {showCommentPopup ? <CommentDialog handleCloseComments={handleCloseComments} handleAction={handleArchive} /> : <></>}
        </Grid2>
      ) : (
        <></>
      )}
    </LoadingIndicator>
  );
}
